export default __webpack_public_path__ + "static/media/slider-1.8136e061.jpeg";